import { useQuery } from '@provision/graphql-client';
import { isNullish } from 'remeda';
import { GET_ACTIVATION_FLOW_CONFIG_BRAND_LINKS_QUERY } from 'src/graphql/entities/activation-flow-config/activation-flow-config.operations';

type BrandActivationLinksData = {
  getBundledActivationFlowConfig: {
    id: string;
    options?: {
      termsOfServiceUrl?: string | null;
      privacyPolicyUrl?: string | null;
      contactSupportLink?: string | null;
    } | null;
  };
};

type BrandActivationLinksVars = {
  input: { brandId: string; partnerId: string };
};

interface UseBrandActivationLinksParams {
  partnerId: number | null | undefined;
  brandId: string | null | undefined;
}

export const useBrandActivationLinks = ({
  partnerId,
  brandId,
}: UseBrandActivationLinksParams) => {
  const shouldSkip = isNullish(partnerId) || isNullish(brandId);

  const { data, loading, error, refetch } = useQuery<
    BrandActivationLinksData,
    BrandActivationLinksVars
  >(GET_ACTIVATION_FLOW_CONFIG_BRAND_LINKS_QUERY, {
    skip: shouldSkip,
    variables: shouldSkip
      ? undefined
      : {
          input: {
            partnerId: String(partnerId),
            brandId,
          },
        },
  });

  return {
    activationFlowConfigId: data?.getBundledActivationFlowConfig?.id ?? null,
    termsOfServiceUrl: data?.getBundledActivationFlowConfig?.options?.termsOfServiceUrl ?? '',
    privacyPolicyUrl: data?.getBundledActivationFlowConfig?.options?.privacyPolicyUrl ?? '',
    contactSupportLink:
      data?.getBundledActivationFlowConfig?.options?.contactSupportLink ?? '',
    loading,
    error,
    refetch,
  };
};
